import { render, staticRenderFns } from "./add-item-form.vue?vue&type=template&id=abe93b80"
import script from "./add-item-form.vue?vue&type=script&lang=js"
export * from "./add-item-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abe93b80')) {
      api.createRecord('abe93b80', component.options)
    } else {
      api.reload('abe93b80', component.options)
    }
    module.hot.accept("./add-item-form.vue?vue&type=template&id=abe93b80", function () {
      api.rerender('abe93b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/conversations/add-item-form.vue"
export default component.exports